import { render, staticRenderFns } from "./entryprice.vue?vue&type=template&id=5445a022"
import script from "./entryprice.vue?vue&type=script&lang=js"
export * from "./entryprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports